/**
 * Confirmation-toast label for a human pair verdict (AW-54).
 *
 * "Same organization (keep both)" posts `separate + same_org_dual_role` —
 * structurally a separate (cross-type pairs can never merge) but a distinct
 * verdict to the customer. A bare "Kept separate" toast on that click reads
 * as the WRONG verdict having been saved (Dub filed AW-54 doubting his
 * dual-role rulings landed). The label must mirror the choice the user made.
 *
 * AW-63 B6: a group click decides its card in the request and its other pairs
 * in background tasks, so a group's label says they are being decided
 * ("Merging 4 pairs"), never that they are done.
 */
export function verdictToastLabel(
  verdict: 'merge' | 'separate',
  reasonCode: string | undefined,
  siblingCount: number,
): string {
  if (verdict === 'separate' && reasonCode === 'same_org_dual_role') {
    return siblingCount > 1
      ? `Same organization — keeping both records (${siblingCount} pairs)`
      : 'Same organization — kept both records';
  }
  if (siblingCount > 1) {
    return verdict === 'merge'
      ? `Merging ${siblingCount} pairs`
      : `Keeping ${siblingCount} pairs separate`;
  }
  return verdict === 'merge' ? 'Merged' : 'Kept separate';
}

/**
 * Confirmation-toast label for an Undo (AW-63 B6). Undoing a group click
 * reverts its row at once and the group's other pairs in background tasks;
 * `siblingCount` is the count the Undo answered (absent from an older engine).
 */
export function revertToastLabel(siblingCount: number | undefined): string {
  return siblingCount !== undefined && siblingCount > 1
    ? `Undoing ${siblingCount} pairs`
    : 'Decision reverted';
}
